<template>
  <div>
    <div class="banner">
      <!-- <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;"> -->
    </div>
    <section class="has-background-light">
      <br><h1 class="title is-4">ลงทะเบียนรับรถเข้าศูนย์ สาขา {{ branchSelected }}</h1>
    </section>
    <section class="hero has-background-light is-fullheight" v-show="!sendQRSuccess">
      <div class="hero-body-custom" >
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
              <div class="container"><br>
                <h3 class="title is-5">กรุณากรอกข้อมูล</h3>
                <p v-if="errors.length">
                  <ul>
                    <li v-for="error in errors" v-bind:key="error" class="has-text-danger">{{ error }}</li>
                  </ul><br>
                </p>

                <div class="field">
                  <label class="label">ชื่อลูกค้า <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ชื่อลูกค้า" v-model="carInfo.customerName">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เบอร์โทร <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เบอร์โทรลูกค้า" v-model="carInfo.customerTel">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขตัวถัง <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขตัวถัง" v-model="carInfo.frameNo">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขทะเบียน <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขทะเบียน" v-model="carInfo.licenseNo">
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">รุ่นรถ</label>
                      <div class="select">
                        <select v-model="carInfo.Model">
                          <option v-for="model in models" v-bind:key="model" :value="model" >{{ model }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <label class="label">สีของรถ</label>
                      <div class="select">
                        <select v-model="carInfo.carColor">
                          <option v-for="color in colors" v-bind:key="color.title" :value="color.title" >{{ color.title }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div><br>
                <div class="field">
                  <label class="radio">
                    <input type="radio" name="paymentMethod" value="cash" v-model="carInfo.paymentMethod" >&nbsp;&nbsp;&nbsp;<b>เงินสด</b>
                  </label>
                  <label class="radio">
                    <input type="radio" name="paymentMethod" value="insurance" v-model="carInfo.paymentMethod" >&nbsp;&nbsp;&nbsp;<b>เงินประกัน</b>
                  </label>
                </div><br>
                <div class="field" v-if="carInfo.paymentMethod !== 'cash'">
                  <label class="label">บริษัทประกันภัย <span class="has-text-danger">*</span></label>
                  <div class="select">
                    <select v-model="carInfo.Insurrance">
                      <option v-for="insurrance in insurrances" v-bind:key="insurrance" :value="insurrance" >{{ insurrance }}</option>
                    </select>
                  </div>
                </div>
                <div class="field" v-show="carInfo.Insurrance == 'other'">
                  <label class="label">บริษัทประกันภัยอื่นๆ <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="บริษัทประกันภัยอื่นๆ" v-model="carInfo.insurranceOther">
                  </div>
                </div>
                <div class="field">
                  <label class="label">พนักงานประเมินราคา <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="พนักงานประเมินราคา" v-model="carInfo.staffEstimate">
                  </div>
                </div>
                <br>
                <button class="button is-success" v-on:click="submitCarInfo">{{ btn_action }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <article class="message is-success" v-show="sendQRSuccess">
      <div class="message-header">
        <p>ส่ง QR Code ไปที่ LINE Group Admin เรียบร้อยแล้ว</p>
      </div>
      <div class="message-body">
        <button class="button is-link" v-on:click="newCustomer">รับลูกค้าใหม่</button>
      </div>
    </article>
  </div>
</template>
<style>
.hero-body-custom {
  display: flex;
  padding: 0 !important;
}
.banner {
  text-align: center;
  background-color: #000;
}
input[type=checkbox] {
  padding: 10px;
          transform: scale(2);

  -webkit-transform: scale(2); /* Safari and Chrome */
     -moz-transform: scale(2); /* FF */
  /* Double-sized Checkboxes */
      -ms-transform: scale(2); /* IE */
       -o-transform: scale(2); /* Opera */
}

/* Might want to wrap a span around your checkbox text */
.checkboxtext {
  display: inline;
  /* Checkbox text */
  font-size: 110%;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'Home',
  beforeCreate () {
    // if (!this.$session.exists()) {
    //   this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    // } else {
    //   this.$liff.init({ liffId: this.$liffId_Service_Register }, function (data) {})
    // }
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    urlconfirm: 'https://liff.line.me/1653760842-vxdJxgNo?',
    size: 200,
    registerSuccess: false,
    sendQRSuccess: false,
    errors: [],
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    branch: [],
    branchSelected: '',
    branchCode: '',
    carInfo: {
      branchId: '',
      customerName: '',
      customerTel: '',
      frameNo: '',
      licenseNo: '',
      paymentMethod: false,
      Insurrance: '',
      insurranceOther: '',
      staffEstimate: ''
    },
    carId: '',
    btn_action: 'Submit',
    updatedBy: '',
    insurrances: [
      '',
      'บริษัท กรุงเทพประกันภัย จำกัด (มหาชน)',
      'บริษัท ธนชาตประกันภัย จำกัด (มหาชน)',
      'บริษัท คุ้มภัยโตเกียวมารีนประกันภัย (ประเทศไทย) จำกัด (มหาชน)',
      'บริษัท ซมโปะ ประกันภัย (ประเทศไทย) จำกัด (มหาชน)',
      'บริษัท แอกซ่าประกันภัย จำกัด (มหาชน)',
      'บริษัท มิตซุย สุมิโตโม อินชัวร์รันซ์ จำกัด (สาขาประเทศไทย)',
      'บริษัท แอลเอ็มจี ประกันภัย จำกัด (มหาชน)',
      'บริษัท สินทรัพย์ประกันภัย จำกัด',
      'บริษัท สินมั่งคงประกันภัย จำกัด',
      'บริษัท เอ็ม เอส ไอ จี ประกันภัย จำกัด',
      'บริษัท ทิพยประกันภัย จำกัด (มหาชน)',
      'บริษัท วิริยะประกันภัย จำกัด (มหาชน)',
      'บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน)',
      'บริษัท อลิอันซ์ อยุธยา ประกันภัย จำกัด (มหาชน)',
      'บริษัท อาคเนย์ประกันภัย จำกัด (มหาชน)',
      'บริษัท ไทยศรีประกันภัย จำกัด',
      'บริษัท เมืองไทยประกันภัย จำกัด',
      'other'
    ],
    models: [
      '', 'Accord', 'Accord. EHEV', 'CR-V e HEV', 'BR-V', 'WR-V', 'Brio Amaze', 'Brio', 'CR-V', 'City', 'CIVIC e:Hev',
      'Civic Hatchback', 'Civic', 'HR-V', 'HRV e:HEV', 'Jazz', 'Mobilio', 'Freed',
      'STEPWAGON', 'ODYSSEY', 'STREAM'
    ],
    colors: [
      { 'code': 'Blue', 'title': 'Blue' },
      { 'code': 'Black', 'title': 'Black' },
      { 'code': 'Red', 'title': 'Red' },
      { 'code': 'Silver', 'title': 'Silver' },
      { 'code': 'Gray', 'title': 'Gray' },
      { 'code': 'Orange', 'title': 'Orange' },
      { 'code': 'White', 'title': 'White' },
      { 'code': 'Green', 'title': 'Green' },
      { 'code': 'Brown', 'title': 'Brown' },
      { 'code': 'Yellow', 'title': 'Yellow' },
      { 'code': 'MMB', 'title': 'MMB' },
      { 'code': 'PSW', 'title': 'PSW' },
      { 'code': 'IRB', 'title': 'IRB' },
      { 'code': 'STD', 'title': 'STD' },
      { 'code': 'CYB', 'title': 'CYB' },
      { 'code': 'SKC', 'title': 'KHAKI SAND' }
    ]
  }),
  async mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    let _this = this
    _this.updatedBy = this.$session.get('vgroup')
    _this.branch = this.$branchList
    // if (process.env.NODE_ENV === 'development') {
    //   this.getProfile_dev()
    // } else {
    //   this.getProfile()
    // }
    const queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    const params = new URLSearchParams(queryString)
    const branchCode = params.get('branchCode')
    _this.branchCode = branchCode
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    this.getToday()
  },
  methods: {
    getToday () {
      const date = new Date()
      this.carInfo.expectedDate = ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear()
    },
    newCustomer () {
      this.carInfo.staffEstimate = ''
      this.customerTel = ''
      this.carInfo.customerName = ''
      this.carInfo.customerTel = ''
      this.carInfo.staffEstimate = ''
      this.carInfo.frameNo = ''
      this.carInfo.licenseNo = ''
      this.carInfo.Insurrance = ''
      this.carInfo.insurranceOther = ''
      this.carInfo.paymentMethod = false
      this.carInfo.Model = ''
      this.carInfo.carColor = ''
      this.btn_action = 'Submit'
      this.errors = []
      this.registerSuccess = false
      this.sendQRSuccess = false
      this.getToday()
    },
    checkForm (e) {
      if (this.carInfo.customerName && this.carInfo.customerTel && this.carInfo.Model && this.carInfo.carColor && this.carInfo.staffEstimate && this.carInfo.frameNo && this.carInfo.licenseNo) {
        return true
      }

      this.errors = []
      if (!this.carInfo.customerName) {
        this.errors.push('กรุณากรอกชื่อลูกค้า')
      }
      if (!this.carInfo.customerTel) {
        this.errors.push('กรุณากรอกเบอร์โทรลูกค้า')
      }
      if (!this.carInfo.frameNo) {
        this.errors.push('กรุณากรอกเลขตัวถัง')
      }
      if (!this.carInfo.licenseNo) {
        this.errors.push('กรุณากรอกเลชทะเบียน')
      }
      if (!this.carInfo.Model) {
        this.errors.push('กรุณาเลือกรุ่นรถ')
      }
      if (!this.carInfo.carColor) {
        this.errors.push('กรุณาเลือกสีรถ')
      }
      if (!this.carInfo.paymentMethod) {
        this.errors.push('กรุณาเลือกเงื่อนไขการชำระเงิน')
      }
      // if (!this.carInfo.Insurrance) {
      //   this.errors.push('กรุณาเลือกบริษัทประกัน')
      // }
      if (!this.carInfo.staffEstimate) {
        this.errors.push('กรุณากรอกเจ้าหน้าที่ประเมินราคา')
      }

      e.preventDefault()
    },
    submitCarInfo (e) {
      let _this = this
      if (!this.checkForm(e)) {
        return false
      }
      _this.btn_action = 'Waiting...'
      _this.carInfo.branchId = _this.branchCode
      let params = {
        carInfo: _this.carInfo,
        updatedBy: _this.updatedBy
      }
      this.$axios
        .post(`${this.$apiUrl}setBPInfo`, params)
        .then(response => {
          _this.carId = response.data.carId
          _this.urlconfirm += `branchCode=${_this.branchCode}&carId=${_this.carId}`
          _this.registerSuccess = true
          if (process.env.NODE_ENV !== 'development') {
            _this.sendQRCodeToSA()
          } else {
            _this.sendQRSuccess = true
            _this.sendQRCodeToSA()
          }
        })
    },
    sendQRCodeToSA () {
      let _this = this
      console.log(_this.carInfo)
      this.$axios
        .get(`${this.$apiUrl}sendQRCodeBPToSA?customerName=${_this.carInfo.customerName}&pictureUrl=${_this.profile.pictureUrl}&licenseNo=${_this.carInfo.licenseNo}&frameNo=${_this.carInfo.frameNo}&staffEstimate=${_this.carInfo.staffEstimate}&branchCode=${_this.branchCode}&carId=${_this.carId}`)
        .then(response => {
          _this.sendQRSuccess = true
        })
    },
    openWindow () {
      this.$liff.openWindow({
        url: 'https://developers.line.me/en/docs/liff/overview/'
      })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    getProfile_dev () {
      this.profile = {
        'displayName': 'Pamorn Trivorrarat',
        'pictureUrl': 'https://profile.line-scdn.net/0hehdTyqPSOkdZLRSQHV5FEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
        'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
        'userId': 'U691b2080970333bbeb4930dadc6618b6'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegisterBP.vue